import { AlertCircle } from "lucide-react";
import { Reveal } from "@/lib/reveal";
import { PROBLEM_POINTS } from "@/data/content";

export const Problem = () => {
  return (
    <section id="problem" className="relative py-20 lg:py-32" data-testid="problem-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="text-xs font-mono uppercase tracking-[0.24em] text-teal">The problem</span>
              <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white leading-tight">
                People with disabilities shouldn’t have to keep explaining what support they need to access the world.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-lg text-slate-300 leading-relaxed">
                Accessibility information is often spread across different organisations, services
                and systems that don’t communicate with each other. A person with a disability may
                provide important information to healthcare, transport, accommodation, employment,
                education, events and other services, yet that information doesn’t necessarily move
                with them.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.06}>
              <ul className="space-y-3">
                {PROBLEM_POINTS.map((p, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-4 rounded-2xl glass p-5"
                    data-testid={`problem-point-${i}`}
                  >
                    <AlertCircle className="mt-0.5 h-5 w-5 shrink-0 text-teal" aria-hidden="true" />
                    <span>
                      <span className="block font-display text-base font-semibold text-white">{p.title}</span>
                      <span className="mt-1 block text-base text-slate-300 leading-relaxed">{p.detail}</span>
                    </span>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
